module.exports = __webpack_public_path__ + "8a4a4ae9151c9b274fa55308ab83581b.pdf";